import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import FNMAuthContext from "../../store/FNMStore/FNM-auth-context";

const RequireFNMFormAuth = () => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(FNMAuthContext);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/form-network-marketer/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default RequireFNMFormAuth;
